module.exports = __webpack_public_path__ + "static/media/logo-arrayanes-blanco.306fc95a.png";